/**
 * @auth 赖传峰
 * @date 2022/3/28
 */
import { defineStore } from 'pinia'

interface LayoutState {
  sidebarMobileVisible: boolean
  i18nMenuPopoverVisible: boolean
  isMobile: boolean
  darkMode: boolean
  serverTime: number
  /** 折叠模式: Footer 将会收起 */
  isCollapse: boolean
  routingPath: string | null // 当前正在打开的路由，如果匹配到文件夹路径，则在文件夹上添加 loading 动画
}

export const useLayout = defineStore<'layout', LayoutState>('layout', {
  state: () => ({
    sidebarMobileVisible: false,
    i18nMenuPopoverVisible: false,
    isMobile: false,
    darkMode: false,
    serverTime: new Date().getTime(),
    isCollapse: false,
    routingPath: null,
  }),
})
